const SURVEY_TYPE_KEYS: Record<string, string> = {
  "long-term": "surveyForm.surveyTypeLongTerm",
  workshop: "surveyForm.surveyTypeWorkshop",
  delivery: "surveyForm.surveyTypeDelivery",
};

export const surveyTypeLabel = (surveyType: string | undefined) => SURVEY_TYPE_KEYS[surveyType || ""] || SURVEY_TYPE_KEYS["long-term"];

// The short category names the app already uses, so influence reads Social.
export const categoryLabel = (question: string) => `improvementGoals.${question}Label`;
